import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectPagesRoute: InvariantJiraRoute = {
	name: 'project-pages',
	path: '/jira/core/projects/:projectKey/pages',
};
